export enum ApiSelector {
  AUTH = 1,
  BUSINESS_LOGIC,
  COMMON,
  PRICING,
}
